import React, { useEffect, useRef, useState } from "react";
import { dashboardColors, theme } from "../../../../themes/Theme";
import cardView from "../../../../assets/img/reports/card-view.svg";
import tableView from "../../../../assets/img/reports/table-view.svg";
import downloadSvg from "../../../../assets/img/reports/download.svg";
import FilterDropdown from "./FilterDropdown";
import moment from "moment";
import CustomDateRangeModal from "./CustomDateRangeModal";
import customToast from "../../../../components/common/basic/Toast";
import DisplayCustomSelectedDate from "../DisplayCustomSelectedDate";

const EventsSummaryHeader = ({
  eventStatus = "past", 
  dateFilter = "lastWeek", 
  viewType = "card", 
  eventsCount = 0, 
  onEventStatusChange = () => { }, 
  onDateFilterChange = () => { }, 
  onDownloadCSV = () => { }, 
  eventStatusOptions = [], 
  dateFilterOptions = [], 
  viewTypeOptions = [], 
  timeZone = "IST", 
  setFilteredDataConfig = () => { }, 
  DateTimeComponent = null, 
  setSelectedFilters = () => { },
  onViewTypeChange = () => { },
}) => {


  const [openDateModal, setOpenDateModal] = useState(false);
  const [isCustomDateSelected, setIsCustomDateSelected] = useState(false)
  const modalRef = useRef(null);
  const [customDateRange, setCustomDateRange] = useState({
    startDate: null,
    endDate: null,
    isActive: false
  });
  const handleCustomDateProceed = (selectedDates) => {
    const { startDate, endDate } = selectedDates;

    if (!startDate || !endDate) {
      customToast.error('Missing dates:', { startDate, endDate })
      return;
    }
    const newCustomRange = {
      startDate: selectedDates?.startDate,
      endDate: selectedDates?.endDate,
      isActive: true
    };

    setCustomDateRange(newCustomRange);
    const startFormatted = moment(startDate).format('MMM DD, YYYY');
    const endFormatted = moment(endDate).format('MMM DD, YYYY');

    //  Pass to parent with correct structure
    const filterData = {
      value: 'custom',
      label: `${startFormatted} - ${endFormatted}`,
      startDate: startDate,  
      endDate: endDate        
    };
    onDateFilterChange(filterData);
    setIsCustomDateSelected(true)
  };

  const handleDateFilterChange = (option) => {
    if (option.value === "custom") {
      setIsCustomDateSelected(false)
      setOpenDateModal(true);
    } else {
      onDateFilterChange(option);
      setIsCustomDateSelected(false)

    }
  };
  return (
    <div className="">
      <div className="d-flex flex-column richtext-gap-3">
        <div className="events-summary-header">
          <div className="d-flex align-items-center richtext-gap-3">
            <p className="event-summary-label mb-0">Events Summary</p>
            <span className="event-summary-count">Count: {eventsCount}</span>
            { isCustomDateSelected  && <DisplayCustomSelectedDate startDate={customDateRange?.startDate} endDate={customDateRange?.endDate} />}
          </div>

          <div className="event-summary-header-controls">
            {/* Event Status Dropdown */}

            <FilterDropdown
              options={eventStatusOptions || []}
              value={eventStatus}
              onChange={onEventStatusChange}
              className="event-status-filter"
              placeholder="Active Events"
            />

            {/* Date Filter Dropdown */}
            <FilterDropdown
              options={dateFilterOptions || []}
              value={dateFilter}
              onChange={handleDateFilterChange}
              onCustomSelect={() => setOpenDateModal(true)}
              className="date-filter"
              placeholder="Last Week"
            />


            <div className="mr-1">
              <div className="">
                <div
                  className="cursor-pointer"
                  onClick={() =>
                    onViewTypeChange({
                      value: viewType === "card" ? "table" : "card",
                    })
                  }
                >
                  {viewType === "card" ? (
                    
                    <img src={tableView} alt="" />
                  ) : (
                    <img src={cardView} alt="" />
                  )}
                </div>
              </div>
            </div>


            {/* <img
              className="cursor-pointer"
              src={downloadSvg}
              onClick={onDownloadCSV}
              alt=""
            /> */}
          </div></div>
        {openDateModal && <CustomDateRangeModal
          ref={modalRef}
          isOpen={openDateModal}
          onClose={() => {
            setOpenDateModal(false);
          }}
          onProceed={handleCustomDateProceed}
          timeZone={timeZone}
          initialStartDate={customDateRange?.startDate || null}
          initialEndDate={customDateRange?.endDate || null}
        />}

      </div>
      <style>{`
                .events-summary-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 30px  0px 20px;
                    flex-wrap: wrap;
                    gap: 15px;
                    padding: 15px 20px 5px;
                }
.event-summary-label {
    font-size: 18px;
    font-weight: 600;
    color: #1E1F24;
}
                .header-left {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }

                .header-left h3 {
                    margin: 0;
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #333;
                }

                .event-summary-count {
                    background: #ECF2FF;
                    color: #002E6E;
                    padding: 4px 10px;
                    border-radius: 20px;
                    font-size: 16px;
                    font-weight: 500;
                }

                .event-summary-header-controls {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex-wrap: wrap;
                }


                .cursor-pointer{
                  cursor:pointer;
                }



                @media (max-width: 768px) {
                    .events-summary-header {
                        flex-direction: column;
                        align-items: flex-start;
                        padding: 0 15px;
                    }
                    
                    .event-summary-header-controls {
                        width: 100%;
                        justify-content: flex-start;
                    }
                }
            `}</style>
    </div>
  );
};

export default EventsSummaryHeader;
